module.exports = "<article>\r\n     <app-stations></app-stations>\r\n</article>\r\n\r\n"